import { onMounted, onBeforeUnmount, ref } from 'vue'
import { type BusEvent, eventClient } from '../lib/events'

/**
 * useEvents subscribes to /api/events SSE. Handlers are looked up by event
 * type. Returns a reactive list of the last `keep` events for diagnostic
 * displays. Unsubscribes on unmount.
 */
export function useEvents(
  handlers: Record<string, (e: BusEvent) => void> = {},
  keep = 50,
) {
  const recent = ref<BusEvent[]>([])
  let unsubscribe: (() => void) | null = null

  onMounted(() => {
    unsubscribe = eventClient.subscribe((ev) => {
      recent.value.unshift(ev)
      if (recent.value.length > keep) recent.value.length = keep
      handlers[ev.type]?.(ev)
    })
  })

  onBeforeUnmount(() => {
    unsubscribe?.()
    unsubscribe = null
  })

  return { recent }
}
